import { createRouter, createWebHashHistory } from 'vue-router'

// 使用路由懒加载，减少初始加载体积
const Login = () => import('../views/Login.vue')
const Dashboard = () => import('../views/Dashboard.vue')
const Users = () => import('../views/Users.vue')
const Permissions = () => import('../views/Permissions.vue')
const Logs = () => import('../views/Logs.vue')
const Files = () => import('../views/Files.vue')
const Charts = () => import('../views/Charts.vue')
const KnowledgeBase = () => import('../views/KnowledgeBase.vue')
const Consultations = () => import('../views/Consultations.vue')
const Marketing = () => import('../views/Marketing.vue')
const NewAdminLayout = () => import('../layouts/NewAdminLayout.vue')
const Profile = () => import('../views/Profile.vue')
const QrCode = () => import('../views/QrCode.vue')
const WxCode = () => import('../views/WxCode.vue')
const Settings = () => import('../views/Settings.vue')

const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/',
    component: NewAdminLayout,
    children: [
      {
        path: '',
        redirect: '/dashboard'
      },
      {
        path: '/dashboard',
        name: 'dashboard',
        component: Dashboard
      },
      {
        path: '/users',
        name: 'users',
        component: Users
      },
      {
        path: '/permissions',
        name: 'permissions',
        component: Permissions
      },
      {
        path: '/sessions',
        name: 'sessions',
        component: Logs
      },
      {
        path: '/files',
        name: 'files',
        component: Files
      },
      {
        path: '/charts',
        name: 'charts',
        component: Charts
      },
      {
        path: '/knowledge-base',
        name: 'knowledge-base',
        component: KnowledgeBase
      },
      {
        path: '/consultations',
        name: 'consultations',
        component: Consultations
      },
      {
        path: '/profile',
        name: 'profile',
        component: Profile
      },
      
      {
        path: '/marketing',
        name: 'marketing',
        component: Marketing
      },
      {
        path: '/qr-code',
        name: 'qr-code',
        component: QrCode
      },
      {
        path: '/wx-code',
        name: 'wx-code',
        component: WxCode
      },
      {
        path: '/settings',
        name: 'settings',
        component: Settings
      }
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const isAuthenticated = localStorage.getItem('isAuthenticated') === 'true'

  if (to.path === '/login') {
    next()
  } else if (!isAuthenticated) {
    next('/login')
  } else {
    next()
  }
})

export default router
